import React from 'react';
import Article from 'app/blocks/article/article';
import { WhiteBlock } from 'app/blocks/blocks';
import { Button, PrimaryButton } from 'app/blocks/buttons/buttons';
import { withCodes, ID } from 'app/blocks/common/codes';
import PanelAdvanced from 'app/blocks/Panel/advanced/panel_advanced';
import { useOpenAccessOrderFlow } from 'app/pages/orders/oa/OpenAccessOrderContext';
import OrdersPanelContact from 'app/pages/orders/panel/contact';
import OrdersPanelPayment from 'app/pages/orders/panel/payment';
import OrdersPanelQuote from 'app/pages/orders/panel/quote';
import VatOrTaxForm from 'app/pages/orders/panel/vat-tax';

function OrdersOAInitiate({ l }) {
    const {
        initiate: initiateState,
        initiateController: controller,
        isCanceling,
        onCancelOrder,
        order,
        journal,
    } = useOpenAccessOrderFlow();

    const { isGoingNext, isPaymentMethodSupported, isSavingForLater } = initiateState;

    return (
        <div style={{ maxWidth: '768px' }}>
            <div className="m-btm_md">
                <WhiteBlock className="page p-2x">
                    <Article article={order.article} journal={order.journal} openAccess />
                </WhiteBlock>
            </div>

            <div className="m-btm_md">
                <OrdersPanelQuote prices={order.pricingDetails} />
            </div>

            <div className="m-btm_md">
                <PanelAdvanced
                    descr={l('ORDER_PANELS.PANEL_PAYMENT.SUBTITLE')}
                    disableOk={!isPaymentMethodSupported}
                    headerTitle={l('ORDER_PANELS.PANEL_PAYMENT.TITLE')}
                    panel={controller.paymentPanel}
                    seleniumid="order-payment"
                >
                    <OrdersPanelPayment
                        controller={controller.paymentPanel.ctrl}
                        paymentState={initiateState.payment}
                    />
                </PanelAdvanced>
            </div>

            <div className="m-btm_md">
                <PanelAdvanced
                    descr={l('ORDER_PANELS.PANEL_CONTACT.SUBTITLE')}
                    headerTitle={l('ORDER_PANELS.PANEL_CONTACT.TITLE')}
                    panel={controller.contactPanel}
                    seleniumid="contact-panel"
                    toggleEventDone={controller.addressToggleEventDone}
                    toggleEventStart={controller.addressToggleEventStart}
                >
                    <OrdersPanelContact
                        addressesState={initiateState.addresses}
                        controller={controller.contactPanel.ctrl}
                        isOpenAccessOrder
                        toggleHelpAction={controller.panelDispatcher.toggleHelpNote}
                        validationResults={controller.contactPanel.getPanelInfo().validationResults}
                    />
                    <div className="VatTaxPanel-Container">
                        <VatOrTaxForm
                            className="VatTaxPanel"
                            countryCode={order.billingAddress.countryCode}
                            isValidating={initiateState.addresses.isValidating}
                            revenueModel={journal.revenueModel}
                            taxExemptionNumber={initiateState.addresses.vatTaxDetails.taxExemptionNumber}
                            updateTaxExemptionNumber={controller.contactPanel.ctrl.updateTaxExemptionNumber}
                            updateVatIdNumber={controller.contactPanel.ctrl.updateVatIdNumber}
                            vatIdNumber={initiateState.addresses.vatTaxDetails.vatIdNumber}
                        />
                    </div>
                </PanelAdvanced>
            </div>

            <div>
                <div className="m-top_md">
                    <div className="row">
                        <div className="col-3">
                            <Button
                                data-seleniumid="order-cancel-button"
                                disabled={isCanceling}
                                onClick={onCancelOrder}
                            >
                                {isCanceling ? l('BUTTONS.CANCELING') : l('BUTTONS.CANCEL')}
                            </Button>
                        </div>
                        <div className="col-9 text-right">
                            {!(order && order.existing) && (
                                <Button
                                    className="m-l_mini m-btm_mini"
                                    data-seleniumid="order-saveForLater-button"
                                    disabled={isGoingNext || isSavingForLater || controller.isProcessing()}
                                    onClick={controller.saveForLater}
                                >
                                    {!isSavingForLater ? l('BUTTONS.SAVE_FOR_LATER') : l('BUTTONS.SAVING')}
                                </Button>
                            )}
                            <PrimaryButton
                                className="m-l_mini m-btm_mini"
                                data-seleniumid="order-next-button"
                                disabled={
                                    isGoingNext ||
                                    !isPaymentMethodSupported ||
                                    isSavingForLater ||
                                    controller.isProcessing() ||
                                    initiateState.isPaidFlowUndefined
                                }
                                onClick={controller.nextPage}
                            >
                                {!isGoingNext ? l('BUTTONS.SAVE_AND_PREVIEW') : l('BUTTONS.SAVING')}
                            </PrimaryButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withCodes(OrdersOAInitiate, ID.BUTTONS, ID.ORDER_PANELS, ID.LICENSE_SIGNING);
